import styled from 'styled-components';

export const NotificationWrapper = styled.span`
    display: inline-block;
    position: relative;
    margin-right: 50px;
    vertical-align: bottom;
    cursor: pointer;
    user-select: none;
`;